module.exports = __webpack_public_path__ + "img/bigwin-first.1fb19c7a.png";